// ============================================================
// Dashboard Charts Mock Data
// ============================================================

export const mockDashboardCharts = {
  'school-001': {
    monthlyRevenue: [
      { month: 'Jan', revenue: 380000 },
      { month: 'Feb', revenue: 410000 },
      { month: 'Mar', revenue: 395000 },
      { month: 'Apr', revenue: 420000 },
      { month: 'May', revenue: 445000 },
      { month: 'Jun', revenue: 400000 },
    ],
    paymentModeCollection: [
      { name: 'Cash', value: 45000 },
      { name: 'Card', value: 12000 },
      { name: 'UPI', value: 35000 },
      { name: 'Bank Transfer', value: 20000 },
    ],
    pendingFeesByGrade: [
      { grade: 'Grade 1', amount: 15000 },
      { grade: 'Grade 2', amount: 12000 },
      { grade: 'Grade 3', amount: 18000 },
      { grade: 'Grade 4', amount: 9000 },
      { grade: 'Grade 5', amount: 22000 },
    ],
    receiptModeCount: [
      { name: 'Cash', value: 45 },
      { name: 'Card', value: 12 },
      { name: 'UPI', value: 35 },
      { name: 'Bank Transfer', value: 8 },
    ],
    defaultersByGrade: [
      { grade: 'Grade 1', students: 12 },
      { grade: 'Grade 2', students: 8 },
      { grade: 'Grade 3', students: 15 },
      { grade: 'Grade 4', students: 5 },
      { grade: 'Grade 5', students: 18 },
    ],
    attendanceOverview: [
      { day: 'Mon', present: 1180, absent: 70 },
      { day: 'Tue', present: 1200, absent: 50 },
      { day: 'Wed', present: 1150, absent: 100 },
      { day: 'Thu', present: 1190, absent: 60 },
      { day: 'Fri', present: 1170, absent: 80 },
    ],
    studentGrowth: [
      { year: '2020', students: 800 },
      { year: '2021', students: 950 },
      { year: '2022', students: 1050 },
      { year: '2023', students: 1180 },
      { year: '2024', students: 1250 },
    ],
  },
  'school-002': {
    monthlyRevenue: [
      { month: 'Jan', revenue: 280000 },
      { month: 'Feb', revenue: 310000 },
      { month: 'Mar', revenue: 305000 },
      { month: 'Apr', revenue: 320000 },
      { month: 'May', revenue: 330000 },
      { month: 'Jun', revenue: 295000 },
    ],
    paymentModeCollection: [
      { name: 'Cash', value: 30000 },
      { name: 'Card', value: 8000 },
      { name: 'UPI', value: 25000 },
      { name: 'Bank Transfer', value: 15000 },
    ],
    pendingFeesByGrade: [
      { grade: 'Grade 1', amount: 10000 },
      { grade: 'Grade 2', amount: 8000 },
      { grade: 'Grade 3', amount: 12000 },
      { grade: 'Grade 4', amount: 6000 },
      { grade: 'Grade 5', amount: 15000 },
    ],
    receiptModeCount: [
      { name: 'Cash', value: 30 },
      { name: 'Card', value: 8 },
      { name: 'UPI', value: 25 },
      { name: 'Bank Transfer', value: 5 },
    ],
    defaultersByGrade: [
      { grade: 'Grade 1', students: 8 },
      { grade: 'Grade 2', students: 6 },
      { grade: 'Grade 3', students: 10 },
      { grade: 'Grade 4', students: 4 },
      { grade: 'Grade 5', students: 12 },
    ],
    attendanceOverview: [
      { day: 'Mon', present: 940, absent: 40 },
      { day: 'Tue', present: 955, absent: 25 },
      { day: 'Wed', present: 930, absent: 50 },
      { day: 'Thu', present: 950, absent: 30 },
      { day: 'Fri', present: 935, absent: 45 },
    ],
    studentGrowth: [
      { year: '2020', students: 700 },
      { year: '2021', students: 820 },
      { year: '2022', students: 890 },
      { year: '2023', students: 950 },
      { year: '2024', students: 980 },
    ],
  },
  'school-003': {
    monthlyRevenue: [
      { month: 'Jan', revenue: 195000 },
      { month: 'Feb', revenue: 210000 },
      { month: 'Mar', revenue: 200000 },
      { month: 'Apr', revenue: 215000 },
      { month: 'May', revenue: 225000 },
      { month: 'Jun', revenue: 205000 },
    ],
    paymentModeCollection: [
      { name: 'Cash', value: 20000 },
      { name: 'Card', value: 5000 },
      { name: 'UPI', value: 15000 },
      { name: 'Bank Transfer', value: 8000 },
    ],
    pendingFeesByGrade: [
      { grade: 'Grade 1', amount: 5000 },
      { grade: 'Grade 2', amount: 4000 },
      { grade: 'Grade 3', amount: 6000 },
      { grade: 'Grade 4', amount: 3000 },
      { grade: 'Grade 5', amount: 8000 },
    ],
    receiptModeCount: [
      { name: 'Cash', value: 20 },
      { name: 'Card', value: 5 },
      { name: 'UPI', value: 15 },
      { name: 'Bank Transfer', value: 2 },
    ],
    defaultersByGrade: [
      { grade: 'Grade 1', students: 4 },
      { grade: 'Grade 2', students: 3 },
      { grade: 'Grade 3', students: 5 },
      { grade: 'Grade 4', students: 2 },
      { grade: 'Grade 5', students: 6 },
    ],
    attendanceOverview: [
      { day: 'Mon', present: 628, absent: 42 },
      { day: 'Tue', present: 640, absent: 30 },
      { day: 'Wed', present: 615, absent: 55 },
      { day: 'Thu', present: 635, absent: 35 },
      { day: 'Fri', present: 620, absent: 50 },
    ],
    studentGrowth: [
      { year: '2020', students: 500 },
      { year: '2021', students: 550 },
      { year: '2022', students: 600 },
      { year: '2023', students: 630 },
      { year: '2024', students: 670 },
    ],
  },
};
